import { render, staticRenderFns } from "./ComboContexto.vue?vue&type=template&id=f0a85154"
import script from "./ComboContexto.vue?vue&type=script&lang=ts"
export * from "./ComboContexto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports